import http from '../../../utils/fetch';
export default {
    showProCode(){
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/showProCode',
            method: 'post'
        });
    },
    shoudongUpdate(query){
        return http({
            url: '/api/swyl/v1/bscForecastForeDetailShoudong/shoudongUpdate',
            method: 'post',
            data: query
        });
    },
    showProduct(obj){
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/showProduct',
            method: 'post',
            params: obj
        });
    },

    showProModel(obj){
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/showModel',
            method: 'post',
            params: obj
        });
    },
    showCode(obj){
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/showCode',
            method: 'post',
            params: obj
        });
    },
    showPage(query){
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/showPage',
            method: 'post',
            params: query
        });
    },
    showPrePage(query){
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetailPre/showPage',
            method: 'post',
            params: query
        });
    },
    selectById(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/selectById',
            method: 'post',
            params: query
        });
    },
    selectByIds(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/selectByIds',
            method: 'post',
            data: query
        });
    },
    showNewSPList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/showNewSPList',
            method: 'post',
            params: query
        });
    },
    showNewSPListPre(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetailPre/showNewSPList',
            method: 'post',
            params: query
        });
    },
    showSPList(query){
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/showSPList',
            method: 'post',
            params: query
        });
    },
    showDZSPList(query){
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/showDZSPList',
            method: 'post',
            params: query
        });
    },
    showDingdlist(query){
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/showDingdlist',
            method: 'post',
            data: query
        });
    },
    isCreateCg(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/isCreateCg',
            method: 'post',
            data: query
        });
    },

    isNeedCreateCg(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/isNeedCreateCg',
            method: 'post',
            params: query
        });
    },
    lockOrder(query){
        return http({
            url: '/api/swyl/v1/demo/viewWxycReport/lockOrder',
            method: 'post',
            data: query
        });
    },
    reviseInventory(query) {
        return http({
            url: '/api/swyl/v1/demo/viewWxycReport/reviseInventory',
            method: 'post',
            data: query
        });
    },
    checkRevise(query) {
        return http({
            url: '/api/swyl/v1/demo/viewWxycReport/checkRevise',
            method: 'post',
            params: query
        });
    },
    withdraw(query) {
        return http({
            url: '/api/swyl/v1/demo/viewWxycReport/withdraw',
            method: 'post',
            params: query
        });
    },
    showReportPage(query){
        return http({
            url: '/api/swyl/v1/demo/viewWxycReport/selectPage',
            method: 'post',
            params: query
        });
    },
    selectList(query){
        return http({
            url: '/api/swyl/v1/demo/viewWxycReport/selectList',
            method: 'post',
            params: query
        });
    },
    selectWeekPage(query){
        return http({
            url: '/api/swyl/v1/demo/viewWxycReport/selectWeekPage',
            method: 'post',
            params: query
        });
    },
    selectWeekList(query){
        return http({
            url: '/api/swyl/v1/demo/viewWxycReport/selectWeekList',
            method: 'post',
            params: query
        });
    },
    showOccupy(v) {
        return http.post('/api/swyl/v1/demo/viewWxycReport/showOccupy?id='+v);
    },
    selectCountry(){
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/selectCountry',
            method: 'post'
        });
    },
    getArea(){
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/getArea',
            method: 'post'
        });
    },
    page(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/selectPage',
            method: 'post',
            params: query
        });
    },
    prePage(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetailPre/showPage',
            method: 'post',
            params: query
        });
    },
    selectStock(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/selectStock',
            method: 'post',
            params: obj
        });
    },
    selectStockOther(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/selectStockOther',
            method: 'post',
            params: obj
        });
    },
    selectStockOtherIsCheck(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/selectStockOtherIsCheck',
            method: 'post',
            params: obj
        });
    },
    checkSelectStock(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/checkSelectStock',
            method: 'post',
            params: obj
        });
    },
    checkSelectStockOther(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/checkSelectStockOther',
            method: 'post',
            params: obj
        });
    },
    selectReviseStock(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/selectReviseStock',
            method: 'post',
            params: obj
        });
    },
    selectSPStock(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/selectSPStock',
            method: 'post',
            params: obj
        });
    },
    selectGYuser() {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/selectGYuser',
            method: 'post',
        });
    },
    selectReviseSPStock(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/selectReviseSPStock',
            method: 'post',
            params: obj
        });
    },
    updateWithdraw(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/updateWithdraw',
            method: 'post',
            data: obj
        });
    },
    updateReviseKC(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/updateReviseKC',
            method: 'post',
            data: obj
        });
    },
    updateRevise(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/updateRevise',
            method: 'post',
            data: obj
        });
    },
    showReviseList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/showReviseList',
            method: 'post',
            params: query
        });
    },
    showRevise(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/showRevise',
            method: 'post',
            params: query
        });
    },
    showRevisePre(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetailPre/showRevise',
            method: 'post',
            params: query
        });
    },
    submitNewTo(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/submitNewTo',
            method: 'post',
            data: obj
        });
    },
    submitNewPreTo(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetailPre/submitNewTo',
            method: 'post',
            data: obj
        });
    },
    closeNewPreTo(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetailPre/colseSubmit',
            method: 'post',
            data: obj
        });
    },
    isGroupMarket(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/isGroupMarket',
            method: 'post',
            data: obj
        });
    },
    getSendType(obj) {
        return http({
            url: '/api/swyl/v1/demo/orderSendType/selectList',
            method: 'post',
            data: obj
        });
    },
    subRevise(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/reSubmit',
            method: 'post',
            data: obj
        });
    },
    subRevisePre(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetailPre/reSubmit',
            method: 'post',
            data: obj
        });
    },
    auditForecast(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/auditForecast',
            method: 'post',
            data: obj
        });
    },
    auditForecastPre(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetailPre/auditForecast',
            method: 'post',
            data: obj
        });
    },
    auditCloseForecastPre(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetailPre/auditCloseForecast',
            method: 'post',
            data: obj
        });
    },
    auditForecastOther(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/auditForecastOther',
            method: 'post',
            data: obj
        });
    },
    showList(v) {
        return http.post('/api/swyl/v1/demo/bscForecastForeDetail/showList?bid='+v);
    },
    selectAuditing(v) {
        return http.post('/api/swyl/v1/demo/bscForecastForeDetail/selectAuditing?bid='+v);
    },
    selectAllPlan(v) {
        return http.post('/api/swyl/v1/demo/bscForecastForeDetail/showShengChanPlan?id='+v);
    },
    shTG(obj){
        return http.post('/api/swyl/v1/demo/bscForecastForeDetail/updateStatustrue',obj);
    },
    shBTG(obj){
        return http.post('/api/swyl/v1/demo/bscForecastForeDetail/updateStatusfalse',obj);
    },
    selectCode(v) {
        return http.post('/api/swyl/v1/demo/bscForecastForeDetail/selectProCode?proModel='+v);
    },
    selectModel(v) {
        return http.post('/api/swyl/v1/demo/bscForecastForeDetail/selectProModel?proCode='+v);
    },
    selectProType(product,i) {
        return http.post('/api/swyl/v1/demo/bscForecastForeDetail/selectProType?product='+product+"&i="+i);
    },

    selectPreList(obj) {
        return http.post('/api/swyl/v1/demo/bscForecastForeDetailPre/selectList',obj);
    },
    selectOtherPreList(obj) {
        return http.post('/api/swyl/v1/demo/bscForecastForeDetailPre/selectOtherList',obj);
    },
    selectCheckPreList(obj) {
        return http.post('/api/swyl/v1/demo/bscForecastForeDetailPre/selectCheckList',obj);
    },
    isNotPreCount() {
        return http.get('/api/swyl/v1/demo/bscForecastForeDetailPre/isNotPreCount');
    },
    saveTo(obj) {
        return http.post('/api/swyl/v1/demo/bscForecastForeDetail/insert',obj);
    },
    saveToPre(obj) {
        return http.post('/api/swyl/v1/demo/bscForecastForeDetailPre/insert',obj);
    },
    subTo(obj) {
        return http.post('/api/swyl/v1/demo/bscForecastForeDetail/submitTo',obj);
    },
    submitRevise(obj) {
        return http.post('/api/swyl/v1/demo/bscForecastForeDetail/submitRevise',obj);
    },
    release(obj) {
        return http.post('/api/swyl/v1/demo/bscForecastForeDetail/release',obj);
    },
    // deleteId(id){
    //     return http.post('/api/swyl/v1/demo/bscForecastForeDetail/deleteById?id='+id);
    // },
    deleteId(id) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/deleteById?id='+id,
            method: 'post',
        });
    },
    delById(id) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/delById?id='+id,
            method: 'post',
        });
    },
    showDate(id){
        return http.post('/api/swyl/v1/demo/bscForecastForeDetail/showDate?id='+id);
    },



    /**
     * hyl
     * 占用修改查询已预测信息
     * */
    selectReviseStockUpdate(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/selectReviseStockUpdate',
            method: 'post',
            params: obj
        });
    },
    /**
     * hyl
     * 占用修改查询他人预测信息
     * */
    selectStockOtherUpdate(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/selectStockOtherUpdate',
            method: 'post',
            params: obj
        });
    },
    /**
     * hyl
     * 占用修改查询预排信息
     * */
    selectYpUpdate(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetailPre/selectYpUpdate',
            method: 'post',
            params: obj
        });

    },



    /**
     * hyl
     * 查询修改备份
     * */
    selectAdjById(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetailAdj/selectList',
            method: 'post',
            params: query
        });
    },


    /**
     * hyl
     * 释放库存
     * */
    releaseById(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/release',
            method: 'post',
            params: query
        });
    },

    /**
     * hyl
     * 重新计算可录单数量
     * */
    countForecast(ycid) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/countForecast?ycid='+ycid,
            method: 'post',
        });
    },
    //判断是否是冷库产品
    isLk(materialCode) {
        return http({
            url: '/api/swyl/v1/order/bscOrderProductLevelcode/isLengku?materialCode='+materialCode,
            method: 'post',
        });
    },
    //判断是否是冷库产品
    isOemAnd6200(materialCode) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/selectIsOem?product='+materialCode,
            method: 'post',
        });
    },
    //冷库专用生成虚拟预测id
    createLkYcid() {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/createLkYcid',
            method: 'post',
        });
    },
    //判断是否是冷库产品
    checkLkfj(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/checkLkfj',
            method: 'post',
            params: query
        });
    },
    // 预测型号经理审批页面
    showNewXhSPList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/showNewXhSPList',
            method: 'post',
            params: query
        });
    },
    //判断预测审批是否是型号经理之后
    checkXhSp(taskid) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/checkXhSp?taskid='+taskid,
            method: 'post',
        });
    },
    checkDownload(id){
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/checkDownload',
            method: 'post',
            params: {id:id}
        });
    },

    updateUseNumber(id) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/updateUseNumber?id='+id,
            method: 'post',
        });
    },

    xhZancun(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/xhZancun',
            method: 'post',
            data: obj
        });
    },

    reformPage(query) {
        return http({
            url: '/api/swyl/v1/demo/viewReformDetail/selectPage',
            method: 'post',
            params: query
        });
    },

    sdGetPlan(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/sdGetPlan',
            method: 'post',
            params: query
        });
    },

    submitBatch(obj) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/submitForecastBatch',
            method: 'post',
            data: obj
        });
    },

    copyForecast(id) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastForeDetail/copyForecast?id='+id,
            method: 'post',
        });
    },


}
